import { api } from '@/api/client';
import type { AddToCartPayload, Cart } from '@/types/cart';

/**
 * Cart API — BUILD-PLAN §13.
 *
 * Guest identity is carried by an HttpOnly cookie, which the browser attaches
 * automatically because the client sends `withCredentials`. There is no token
 * to pass here, and none to store — that is deliberate (§29: script cannot
 * read or transplant a cart it cannot see).
 */

export const cartKeys = {
  cart: ['cart'] as const,
};

export function fetchCart(): Promise<Cart> {
  return api.get<Cart>('/cart');
}

export function addToCart(payload: AddToCartPayload): Promise<Cart> {
  return api.post<Cart>('/cart/items', payload);
}

export function updateCartItem(itemId: number, quantity: number): Promise<Cart> {
  return api.patch<Cart>(`/cart/items/${itemId}`, { quantity });
}

export function removeCartItem(itemId: number): Promise<Cart> {
  return api.delete<Cart>(`/cart/items/${itemId}`);
}

export function clearCart(): Promise<Cart> {
  return api.delete<Cart>('/cart');
}
